import { Record } from "immutable";

import { AutoAdjustBackwardsLimit } from "../../../../constants/autoAdjustBackwardsLimit";
import { AutoAdjustDateLevel } from "../../../../constants/autoAdjustDateLevel";
import createFromJS from "../../../createFromJS";
import { IdReferenceList } from "../../helper/IdReferenceList";
import { CalendarRecord } from "./CalendarRecord";
import { DefaultColumnsRecord } from "./DefaultColumnsRecord";
import { ItemCardViewSettingsRecord } from "./ItemCardViewSettingsRecord";
import { MindmapViewSettingsRecord } from "./MindmapViewSettingsRecord";
import { NarrativeSettingsRecord } from "./NarrativeSettingsRecord";
import { NarrativeViewSettingsRecord } from "./NarrativeViewSettingsRecord";
import { RelationshipViewSettingsRecord } from "./RelationshipViewSettingsRecord";
import { SubwayViewSettingsRecord } from "./SubwayViewSettingsRecord";
import { TimelineViewSettingsRecord } from "./TimelineViewSettingsRecord";

export const TimelineDefinitionsRecord = Record({
  includeNarrative: true,
  types: new IdReferenceList(),
  properties: new IdReferenceList(),
  references: new IdReferenceList(),
  calendar: new CalendarRecord(),
  colors: new IdReferenceList(),
  timelineViewSettings: new TimelineViewSettingsRecord(),
  narrativeViewSettings: new NarrativeViewSettingsRecord(),
  narrativeSettings: new NarrativeSettingsRecord(),
  mindmapViewSettings: new MindmapViewSettingsRecord(),
  subwayViewSettings: new SubwayViewSettingsRecord(),
  relationshipViewSettings: new RelationshipViewSettingsRecord(),
  mobileItemCardViewSettings: new ItemCardViewSettingsRecord(),
  autoAdjustLevel: AutoAdjustDateLevel.ResolveConstraints,
  autoAdjustBackwardsLimit: AutoAdjustBackwardsLimit.Today,
  storeRelativePaths: false,
  defaultColumns: DefaultColumnsRecord(),
  overrideNowTimestamp: null
});

const data = {
  objects: {
    calendar: "CalendarRecord",
    timelineViewSettings: "TimelineViewSettingsRecord",
    narrativeViewSettings: "NarrativeViewSettingsRecord",
    narrativeSettings: "NarrativeSettingsRecord",
    relationshipViewSettings: "RelationshipViewSettingsRecord",
    subwayViewSettings: "SubwayViewSettingsRecord",
    mobileItemCardViewSettings: "ItemCardViewSettingsRecord",
    mindmapViewSettings: "MindmapViewSettingsRecord",
    defaultColumns: "DefaultColumnsRecord"
  },
  idLists: {
    types: "TypeRecord",
    properties: "PropertyRecord",
    references: "ReferenceRecord",
    colors: "ColorRecord"
  }
};
createFromJS.registerCallback(
  "TimelineDefinitionsRecord",
  createFromJS.createNestedCallback(TimelineDefinitionsRecord, data)
);
